import * as React from 'react';

import { Grid,  Button, Typography, Fab, IconButton, Backdrop, Menu, MenuItem } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from './cfg/config';
import CONFIG from './cfg/config';

import theme from './themes';

import { connect, Provider } from 'react-redux';

import { AppState, Actions, store, IPageState } from './appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, Bilet, ticketService, Sms, FcmNotification, hotelId, inneService, KarnetService, KarnetLogo, KarnetDoladowania, Doladowania, Doladuj, InfoService, InfoNew, ObiektService } from './api';
import ZakladkiMain, { Zakladka } from './pages/ZakladkiMain';
import ZakladkiSecondary from './pages/ZakladkiSecondary';
import FlagIcons from './components/flags/FlagIcons';

import LockIcon from '@material-ui/icons/Lock';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SmsIcon from '@material-ui/icons/Sms';
import RefreshIcon from '@material-ui/icons/Refresh';
import OknoSms from './pages/OknoSms';
import Serwis from './pages/Serwis';
import Powiadomienia from './pages/Powiadomienia';


import logo from "./zdjecia/image.png"

import WebSocket from './WebSocket';
import KarnetKwotowy from './pages/doladuj/KarnetKwotowy';
import KarnetCzasowy from './pages/doladuj/KarnetCzasowy';
import KarnetOdDo from './pages/doladuj/KarnetOdDo';
import HistoriaDoladowania from './pages/historia/HistoriaDoladowania';
import HistoriaZjazdow from './pages/historia/HistoriaZjazdow';
import TwojKarnet from 'pages/historia/TwojKarnet';
import WypozyczNajwazniejsze from './pages/wypozycz/WypozyczNajwazniejsze';
import Zjedz from './pages/zjedz/Zjedz';
import Zanocuj from './pages/zanocuj/Zanocuj';
import WypozyczHistoria from './pages/wypozycz/WypozyczHistoria';
import ZjedzHistoria from './pages/zjedz/ZjedzHistoria';
import ZanocujHistoria from './pages/zanocuj/ZanocujHistoria';
import Wypozyczenia from './pages/regulaminy/Wypozyczenia';
import Zamowienia from './pages/regulaminy/Zamowienia';
import Zgody from './pages/regulaminy/Zgody';
import ZalinkujNajwazniejsze from './pages/zalinkuj/Najwazniejsze';
import Cenniki from './pages/zalinkuj/Cenniki';
import Inne from './pages/zalinkuj/Inne';
import Web from './pages/web/Web';
import LogoFooter from './components/LogoFooter';
import Podoba from './pages/opinie/Podoba';
import Poprawa from './pages/opinie/Poprawa';
import Sugestia from './pages/opinie/Sugestia';
import MenuAdmin from './pages/Menu'

import DeviceDetector from "device-detector-js";
import Klawiatura from 'pages/Klawiatura';
import themeBlue from 'themeBlue';
import OknoInfo from 'components/OknoInfo';
import DialogError from 'components/DialogError';
import { tabStyle, tabStyleSecondary } from 'pages/TabStyles';
import { ClassNameMap } from '@material-ui/styles';
import RegulaminyFooter from 'components/RegulaminyFooter';
import OknoPrzerwa from 'components/OknoPrzerwa';
import ReactDOM from 'react-dom';
import DialogPlatnoscPoZamknieciu from 'pages/doladuj/DialogPlatnoscPoZamknieciu';
import { sendErrorLog } from 'common/helpers';


export const DARK_BUTTON_COLOR =  "#3a3b3c" //DataGrid.css   //"hsla(215, 15%, 40%, 0.15)"
export const DARK_BACKGROUND_COLOR = "#1f2023"
export const DARK_TEXT_COLOR = "#fff"
export const DARK_TEXT_TABLE_COLOR = "#2c9993"


//import sound from '/public/img/sound.mp3'


export enum DisplayStateMain {
  doladuj,
  historia,
  ty_i_my,
  wypozycz,
  zjedz,
  zanocuj,
  zalinkuj,
  opinie,
  web
}

export enum DisplayStateDoladuj {
  kwotowy,
  czasowy,
  od_do
}
export enum DisplayStateHistoria {
  doladowania,
  zjazdy,
  wypozyczenia,
  karnet
}
export enum DisplayStateRegulaminy {
  wypozyczenia,
  zamowienia,
  zgody
}

export enum DisplayStateWypozycz {
  najwazniejsze,
  wypozyczenia,
}
export enum DisplayStateZjedz {
  najwazniejsze,
  zamowienia,
}
export enum DisplayStateZanocuj {
  najwazniejsze,
  noclegi,
}

export enum DisplayStateZalinkuj {
  najwazniejsze,
  cenniki,
  inne
}
export enum DisplayStateOpinie {
  najwazniejsze
  //podoba,
  //poprawa,
  //sugestia,
}
export enum DisplayStateWeb {
  najwazniejsze,
}


interface AppProps {
  page: IPageState
}

interface AppStateInterface {
  width: number,

  panelMain: DisplayStateMain,
  panelSecondary: number,

  karnetNumer: string,
  openKlawiaturaKarnet: boolean,
  openKlawiaturaTelefon: boolean,
  backdropClick: boolean,

  error: boolean,
  text: string,
  //ip: string
  //lightMode: boolean
}



class App extends React.Component<AppProps & WithTranslation & TransProps & WithStyles<typeof styles>, AppStateInterface> {
 
  constructor(props: AppProps & WithTranslation & TransProps & WithStyles<typeof styles>) {
    super(props, {});
    window2config();

    let openK = false
    if(CONFIG.karnetLogo === ""){
      openK = true
    }
   
    this.state = {
      width: window.innerWidth,

      panelMain: DisplayStateMain.doladuj,
      panelSecondary: 0,

      karnetNumer: "",
      openKlawiaturaKarnet: openK,
      openKlawiaturaTelefon: false,
      backdropClick: false,

      error: false,
      text: "",
      //ip: ""
      //lightMode: this.props.page.lightMode
      

    }
    //this.czyOtwartaInnaZakladka() wywołane po pobraniu danych

    // setTimeout(() => {
    //   window.location.reload();
    // }, 21600000); //6h

    window.onbeforeunload = function () {
      sendErrorLog("1", "1", 'stop aplikacji')

    };

  }

  closeTimeout: any;

  async componentDidMount() {
    sendErrorLog("1", "1", 'start aplikacji ' + CONFIG.karnetLogo)
    

    if (CONFIG.karnetPrzerwa !== "1") {
      this.getInfo()
      this.getKarnet();
      //this.getDolodowania();
      this.setKodPlatnosci();
      await this.dajIdenty(CONFIG.hotelId)
    }
   
    

    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);

    //this.getLocalIP()

  }

  componentDidUpdate(prevProps: Readonly<AppProps & WithTranslation & TransProps & { classes: ClassNameMap<'button' | 'root' | 'container' | 'container1' | 'item' | 'paper' | 'title' | 'fab' | 'backdrop' | 'menuItem' | 'green' | 'divider' | 'menuText' | 'inputChosen' | 'inputText' | 'border'>; }>, prevState: Readonly<AppStateInterface>, snapshot?: any): void {
    if(!this.props.page.czyTimer && prevProps.page.czyTimer){
      clearTimeout(this.closeTimeout)
    }
    if(this.props.page.timer !== prevProps.page.timer){
      this.click()
    }
    //console.log(this.props.page.tablet)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowWidth);
  }

  czyOtwartaInnaZakladka = () => {


    const bc = new BroadcastChannel("sprawdzenieDuplikatu");

    bc.onmessage = (event) => {
      if (event.data === `pierwsza`) {
        bc.postMessage(`kolejna`);

        //alert(`Another tab of this site just got opened`);
        console.log("Another tab of this site just got opened")
        this.setState({text: "pierwsza"})

      }
      if (event.data === `kolejna`) {
        ////////////////////////////////////////////////////////////// zamknięcie okna po płatności
        let linkSearch = window.location.search
        if (linkSearch.includes("paymentId") || linkSearch.includes("paymentStatus")) {
          window.close()
        }
        //////////////////////////////////////////////////////////////
        //alert(`An instance of this site is already running`);
        console.log("An instance of this site is already running")
        this.setState({text: "inna"})
      }
    };

    bc.postMessage(`pierwsza`);

    setTimeout(() => {
      if(this.state.text === ""){
        //alert("qwe")

        //localStorage.setItem("platnosc", this.props.page.karnet.logo + ":" + res.result[0].toString() + ":" + this.props.platnosc.wplataId + ":" + this.props.page.tablet
        // DEMO-1:123:12:65.00
         let platnosc = localStorage.getItem("platnosc")
        
        if(platnosc && platnosc.split(":").length === 4){
          let splitPlatnosc =  platnosc.split(":")
          let logo = splitPlatnosc[0]
          let dokNr = splitPlatnosc[1]
          let karnetId = splitPlatnosc[2]
          let tablet = splitPlatnosc[3] === "1" ? true : false

          store.dispatch(Actions.pageState.setTablet(tablet))
          if(this.props.page.trybCiemnyIdent === "1" && tablet){
            store.dispatch(Actions.pageState.setLightMode(false));
          }

          let karnety = [...this.props.page.karnetKwotowy, ...this.props.page.karnetCzasowy, ...this.props.page.karnetOdDo]
          let karnet = karnety.find(x => x.wplataId === karnetId)
          if(this.props.page.karnet.logo === logo && karnet){


            ReactDOM.render( //hex
              <Provider store={store}>
                <MuiThemeProvider theme={theme}>
                  <DialogPlatnoscPoZamknieciu platnosc={karnet} dokNr={dokNr}/>
                </MuiThemeProvider>
              </Provider>, document.getElementById("dialog"))



            localStorage.removeItem("platnosc")
          }

          
        }
       
      }
      
    }, 100);

  }

  // getLocalIP = () => {
  //   try {

  //     const pc = new RTCPeerConnection({ iceServers: [] });
  //     pc.createDataChannel('');
  //     pc.createOffer(pc.setLocalDescription.bind(pc), () => { });

  //     pc.onicecandidate = (ice) => {
  //       if (ice && ice.candidate && ice.candidate.candidate) {
  //         let myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3})/.exec(ice.candidate.candidate)[1];
  //         console.log(myIP)
  //         if (myIP) { this.setState({ ip: myIP }) }
  //         pc.onicecandidate = () => { };
  //       }
  //     }

  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  getInfo = async() => {  
    let timeout = setTimeout(() => {
      this.setState({error: true})
    }, 3000);


    try {
      let res: InfoNew = await InfoService.getPortalInfo({hotelId: CONFIG.hotelId, domena: "pl" })
      clearTimeout(timeout)
      store.dispatch(Actions.pageState.setPortalInfo(res))
      //console.log(res)
    } catch (error) {
      console.error()
      this.setState({error: true})
      sendErrorLog("0", "-1", '/obiekt/dajPortalInfo')
      store.dispatch(Actions.pageState.addFcmLogMessage("/obiekt/dajPortalInfo", 2))
    }
  }
  
  getKarnet = async() => {  
    try {
      let res: Result<KarnetLogo> = await KarnetService.dajKarnet({parametry: {hotelId: CONFIG.hotelId, karnetLogo: CONFIG.karnetLogo, operatorId: "1" }})
      if(res.result.length > 0){
        await store.dispatch(Actions.pageState.setKarnet(res.result[0]))
        this.getDolodowania();
        this.getTabelaDoladowania();

        //this.setZakladkaDoladowania()
      }else {
        this.setState({openKlawiaturaKarnet: true, backdropClick: false})
      }
      //console.log(res)
    } catch (error) {
      console.error()
      this.setState({error: true})
      sendErrorLog("0", "-1", '/karnet/dajKarnet')
      store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/dajKarnet", 2))
    }
  }
  
  getDolodowania = async() => {  
    try {
      let res: Result<Doladowania> = await Doladuj.dajDoladowania({parametry:{hotelId: CONFIG.hotelId, operatorId: "1", ekartaWwwTyp: this.props.page.karnet.ekartaWwwTyp}})
      await store.dispatch(Actions.pageState.setDoladowania(res.result))
      this.setZakladkaDoladowania()
      this.czyOtwartaInnaZakladka()
      //console.log(res)
    } catch (error) {
      console.error()
      this.setState({error: true})
      sendErrorLog("0", "-1", '/karnet/dajDoladowania')
      store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/dajDoladowania", 2))
    }
  }

  setZakladkaDoladowania = () => {
    if(this.props.page.jestKarnet && (this.props.page.karnetCzasowy.length > 0 || this.props.page.karnetKwotowy.length > 0 || this.props.page.karnetOdDo.length > 0 ) && this.props.page.karnetDoladowania.length > 0){

      let selectKwotowy = this.props.page.karnetKwotowy.find(x => x.wplataId === this.props.page.karnetDoladowania[0].jrWplataDefId)
      if(selectKwotowy){ this.setState({panelSecondary: 0}) }
      let selectCzasowy = this.props.page.karnetCzasowy.find(x => x.wplataId === this.props.page.karnetDoladowania[0].jrWplataDefId)
      if(selectCzasowy){ this.setState({panelSecondary: 1}) }
      let selectOdDo = this.props.page.karnetOdDo.find(x => x.wplataId === this.props.page.karnetDoladowania[0].jrWplataDefId)
      if(selectOdDo){ this.setState({panelSecondary: 2}) }
      
      //if(this.props.page.karnetKwotowy[0] && this.props.page.karnetKwotowy[0].jakRozliczac === this.props.page.karnet.jakRozliczac){ this.setState({panelSecondary: 0}) }
      //if(this.props.page.karnetCzasowy[0] && this.props.page.karnetCzasowy[0].jakRozliczac === this.props.page.karnet.jakRozliczac){ this.setState({panelSecondary: 1}) }
      //if(this.props.page.karnetOdDo[0] && this.props.page.karnetOdDo[0].jakRozliczac === this.props.page.karnet.jakRozliczac){ this.setState({panelSecondary: 2}) }

    }


  }

  getTabelaDoladowania = async() => {
      try {
        let res: Result<KarnetDoladowania> = await KarnetService.dajKarnetDoladowania({ parametry: { hotelId: CONFIG.hotelId, operatorId: "1", karnetEkarta: this.props.page.karnet.ekarta } })
        await store.dispatch(Actions.pageState.setKarnetDoladowania(res.result))
        this.setZakladkaDoladowania()

      } catch (error) {
        console.error()
        sendErrorLog("0", "-1", '/karnet/dajKarnetDoladowania')
        store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/dajKarnetDoladowania", 2))
      }
  
  }

  setKodPlatnosci = async() => {
    if(window.name.includes("MsgWindow")){
      await store.dispatch(Actions.pageState.setTablet(true))
      if(this.props.page.trybCiemnyIdent === "1"){
        store.dispatch(Actions.pageState.setLightMode(false));
      }
      await store.dispatch(Actions.pageState.setTimer())

      if(window.name.includes("Czytnik")){
        sendErrorLog("1", "1", 'otwarcie przez czytnik')
      }
      else if(window.name.includes("Klawiatura")){
        sendErrorLog("1", "1", 'otwarcie przez klawiature')
      }
      //this.click()
    }

    let storageKod = localStorage.getItem("kod");
    if(storageKod){
      if(storageKod !== ""  && storageKod !== "0"){
        //store.dispatch(Actions.pageState.setTablet(true))
      }
      if(CONFIG.platnoscKod2 === storageKod){
        store.dispatch(Actions.pageState.setKanalPlatnosci("2"))
        //alert("2")
      }
      if(CONFIG.platnoscKod3 === storageKod){
        store.dispatch(Actions.pageState.setKanalPlatnosci("3"))
        //alert("3")
      } 
    }
    
  }

  async dajIdenty(id: string) {
    try {

      let res = await ObiektService.dajIdenty({
        aJSON: {
          hotelId: id,
          identyfikator: "",
          operatorId: "1",
        }
      });

      if (res.result.length > 0) {

        let identy = res.result

        let potwierdzAktywny = identy.find(x => x.ident === "smartSkiPotwierdzAktywny")
        if (potwierdzAktywny) {
          store.dispatch(Actions.pageState.setIdentyPotwierdzAktywny(potwierdzAktywny.wartosc));
        }

        let trybCiemny = identy.find(x => x.ident === "trybCiemny")

        if (trybCiemny) {


          store.dispatch(Actions.pageState.setTrybCiemnyIdent(trybCiemny.wartosc));
          //this.setState({trybCiemny: trybCiemny.wartosc === "1"})

          if(this.props.page.tablet){
            store.dispatch(Actions.pageState.setLightMode(trybCiemny.wartosc !== "1"));
          }


        }

      }

    } catch (error) {
      console.log(error);
      await sendErrorLog("0", "-1", '/konfig/dajIdenty I-Zamki')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/konfig/dajIdenty I-Zamki", 2))
    }
  }



  updateWindowWidth = () => {
    this.setState({ ...this.state, width: window.innerWidth });
  }

  setPanelMain = async (panel: number, secondary: number = 0) => {
    this.setState({panelMain: panel, panelSecondary: secondary}) 
  }
  
  setPanelSecondary = async (panel: number) => {
    this.setState({panelSecondary: panel}) 
    //console.log(this.state)
    //console.log(panel)
    //console.log(this.props.page.refresh)

    if(this.state.panelSecondary === panel){
      store.dispatch(Actions.pageState.setRefresh())
    }
  }

  refresh = () => {
    window.location.reload();
  }

  openKlawiatura = () => {
    this.setState({openKlawiaturaKarnet: true, backdropClick: false})
  }
  openKlawiaturaBackdrop = () => {
    this.setState({openKlawiaturaKarnet: true, backdropClick: true})
  }

  wpiszKarnet = (value: any, id: number) => {
    this.setState({openKlawiaturaKarnet: false, openKlawiaturaTelefon: true, karnetNumer: value.toString()})
  }

  closeKlawiatura = () => {
    this.setState({openKlawiaturaKarnet: false, openKlawiaturaTelefon: false,})
  }
  
  closeTelefon = (value: any, id: number) => {
    this.setState({openKlawiaturaKarnet: true, openKlawiaturaTelefon: false})
  }

  closeSite = () => {
    window.close()
  }

  openWindow = () => {
    var myWindow = window.open("https://vsc24.net/vscBramki/bramki/", "MsgWindow", "width=2000,height=2000,titlebar=no,toolbar=no,menubar=no,status=no");
    //myWindow.document.write("<p>This1 is 'MsgWindow'. I am 200px wide and 100px tall!</p>");
    //myWindow?
    //window.close()
    if(myWindow){
      setTimeout(() => {
        myWindow.close();
      }, 1000);
      
    }
    
  }

  click = () => {
    clearInterval(this.closeTimeout)
    if(this.props.page.tablet && this.props.page.czyTimer){
      //console.log("click")
      this.closeTimeout = setTimeout(() => {
        window.close()
      }, 30000); //30s
    }
  }

  setTheme = () => {
    //this.setState({lightMode: !this.state.lightMode})
    store.dispatch(Actions.pageState.setLightMode(!this.props.page.lightMode))

    // useMediaQuery(
    //   {
    //     query: "(prefers-color-scheme: light)",
    //   },
    //   undefined,
    // )
  }

  render() {
    const { t, classes } = this.props;
    //let tloUrl: string = `${CONFIG.apiURL}/hotel/img/${CONFIG.hotelID}/tlo.png`
    //background: `url(${tloUrl})`,

    //console.log(this.state)
    //console.log(this.props.page.timer)

    let menuItemsMain : Zakladka[] =  [
      { value: DisplayStateMain.doladuj, panelOpis: "doładuj" },
      { value: DisplayStateMain.historia, panelOpis: "zobacz" },
      { value: DisplayStateMain.ty_i_my, panelOpis: "Ty i My" }, 
      { value: DisplayStateMain.wypozycz, panelOpis: "wypożycz" }, 
      { value: DisplayStateMain.zjedz, panelOpis: "zjedz" }, 
      { value: DisplayStateMain.zanocuj, panelOpis: "zanocuj" }, 
      { value: DisplayStateMain.zalinkuj, panelOpis: "linki" }, 
      { value: DisplayStateMain.opinie, panelOpis: "opinie" }, 
      { value: DisplayStateMain.web, panelOpis: "web" }, 
    ]



    let menuItemsDoladuj : Zakladka[] =  [
      { value: DisplayStateDoladuj.kwotowy, panelOpis: "karnet kwotowy" },
      { value: DisplayStateDoladuj.czasowy, panelOpis: "karnet czasowy godz" }, 
      { value: DisplayStateDoladuj.od_do, panelOpis: "karnet czasowy od-do" },
    ]
    let menuItemsHistoria : Zakladka[] =  [
      { value: DisplayStateHistoria.doladowania, panelOpis: "twoje doładowania" },
      { value: DisplayStateHistoria.zjazdy, panelOpis: "twoje zjazdy" }, 
      // { value: DisplayStateHistoria.wypozyczenia, panelOpis: "wypożyczenia" },
      { value: DisplayStateHistoria.karnet, panelOpis: "twój karnet" }, 
    ] 
    let menuItemsRegulaminy : Zakladka[] =  [
      { value: DisplayStateRegulaminy.wypozyczenia, panelOpis: "regulamin wypożyczenia" },
      { value: DisplayStateRegulaminy.zamowienia, panelOpis: "regulamin zamówienia" }, 
      { value: DisplayStateRegulaminy.zgody, panelOpis: "twoje zgody" },
    ] 

    let menuItemsWypozycz : Zakladka[] =  [
      { value: DisplayStateWypozycz.najwazniejsze, panelOpis: "najważniejsze" },
      { value: DisplayStateWypozycz.wypozyczenia, panelOpis: "twoje wypożyczenia" }, 
    ] 
    let menuItemsZjedz : Zakladka[] =  [
      { value: DisplayStateZjedz.najwazniejsze, panelOpis: "najważniejsze" },
      { value: DisplayStateZjedz.zamowienia, panelOpis: "twoje zamówienia" }, 
    ] 
    let menuItemsZanocuj : Zakladka[] =  [
      { value: DisplayStateZanocuj.najwazniejsze, panelOpis: "najważniejsze" },
      { value: DisplayStateZanocuj.noclegi, panelOpis: "twoje noclegi" }, 
    ] 

    let menuItemsZalinkuj : Zakladka[] =  [
      { value: DisplayStateZalinkuj.najwazniejsze, panelOpis: "najważniejsze" },
      { value: DisplayStateZalinkuj.cenniki, panelOpis: "cenniki" },
      //{ value: DisplayStateZalinkuj.inne, panelOpis: "inne" },
    ]
    let menuItemsOpinie : Zakladka[] =  [
      { value: DisplayStateOpinie.najwazniejsze, panelOpis: "najważniejsze" },
      //{ value: DisplayStateOpinie.podoba, panelOpis: "to mi się podoba" },
      //{ value: DisplayStateOpinie.poprawa, panelOpis: "to wymaga poprawy" },
      //{ value: DisplayStateOpinie.sugestia, panelOpis: "mam sugestię aby" },
    ]
    let menuItemsWeb : Zakladka[] =  [
      { value: DisplayStateWeb.najwazniejsze, panelOpis: "gdzie otwierać link" },
    ]

    let displayMain = this.state.panelMain
    let displaySecondary = this.state.panelSecondary
    let menuItemsSecondary = menuItemsDoladuj

    switch (displayMain) {
      case DisplayStateMain.doladuj:
        menuItemsSecondary = menuItemsDoladuj
        break;
      case DisplayStateMain.historia:
        menuItemsSecondary = menuItemsHistoria
        break;  
      case DisplayStateMain.ty_i_my:
        menuItemsSecondary = menuItemsRegulaminy
        break;  
      case DisplayStateMain.wypozycz:
        menuItemsSecondary = menuItemsWypozycz
        break; 
      case DisplayStateMain.zjedz:
        menuItemsSecondary = menuItemsZjedz
        break;
      case DisplayStateMain.zanocuj:
        menuItemsSecondary = menuItemsZanocuj
        break;
      case DisplayStateMain.zalinkuj:
        menuItemsSecondary = menuItemsZalinkuj
        break;
      case DisplayStateMain.opinie:
        menuItemsSecondary = menuItemsOpinie
        break;
      case DisplayStateMain.web:
        menuItemsSecondary = menuItemsWeb
        break;
      
    }

    //let date = new Date().toTimeString().slice(0,5)

    let title = this.props.page.karnet.karnetStanTekst ? this.props.page.karnet.karnetStanTekst : "KARNET"
    if(!this.props.page.jestKarnet){
      title = "KARNET"
    }

    // const deviceDetector = new DeviceDetector();
    // //const userAgent = "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.81 Safari/537.36";
    // const userAgent = navigator.userAgent
    // const device = deviceDetector.parse(userAgent);
    // let name = device.client?.name + device.client?.version + "|" + device.os?.name + device.os?.version + "|" + device.device?.type 
    // //+ device.client?.version //device.os?.version +
    // console.log(device);

    ///*fontSize: "1.5rem"*/

    let tablet = this.props.page.tablet

    return (
      <div className={`${classes.root} ${this.props.page.lightMode ? classes.lightMode : classes.darkMode}`} onClick={this.click} style={{zoom: tablet? "1.2" : "1", padding: tablet? "45px 30px 10px" : "20px 30px 10px", minHeight: tablet ? "calc(100vh + -55px)" : "calc(100vh + -30px)"}}>
        <MuiThemeProvider theme={theme}>

          {this.state.error? 
                <DialogError error={true} /> : null}

          {CONFIG.karnetPrzerwa === "1" ? <OknoPrzerwa/> : null}      

        <Grid container className={classes.container} >
          {/* <button onClick={this.openWindow} >qwwe</button> */}
            {/* {this.state.ip} */}
            {/* <FlagIcons /> */}
            
            <Grid container direction="column" alignItems='center' justify="center">
              <Grid item xs={12} style={{ width: "100%", position: "relative", margin: tablet ? "10px 0px" : "0px" }}>
                <Grid container justify="center" alignItems="center" className={classes.title} style={{position: "relative"}}> {/**/}
                  {this.state.width > 600 && this.state.width < 1000 ? <MenuAdmin lightMode={this.props.page.lightMode} setTheme={this.setTheme} /> : null}
                  <CreditCardIcon style={{ fontSize: tablet ? "40px" : "30px", color: "rgb(255, 165, 0)" }} />
                  <Typography variant="h6" component="h2" color="primary" style={{ paddingLeft: "10px", fontSize: tablet ? "30px" : "20px", color: "lightseagreen" }}> 
                    <b>{title}</b>
                  </Typography>

                  {/* <Typography variant="h6" component="h2" color="primary" style={{  fontSize: "1.5rem", color: "#777" }}>
                    {"Karnet: "}<b style={{color: "lightseagreen"}} >{"zjazdów 3"}</b>
                  </Typography>

                  <Typography variant="h6" component="h2" color="primary" style={{ position: "absolute", right: "0px", fontSize: "1.5rem", color: "#777" }}>
                    {date}
                  </Typography> */}
                  
                </Grid>
                {/* <Tooltip title="szczegóły" classes={{ tooltip: classes.tooltip }}> */}
                {/* <IconButton style={{ position: "absolute", top: "0", right: "40px", padding: '6px' }} onClick={this.refresh}>
                  <RefreshIcon style={{ width: "25px", height: "25px" }} fontSize="small" />
                </IconButton> */}

                

              
                {/* <Typography variant="h6" component="h2" color="primary" style={{ fontSize: "1.5rem", color: "#777" }}>
                  {name}
                </Typography> */}
              

                  {/* </Tooltip> */}
              </Grid>
            </Grid>

            <ZakladkiMain
              windowWidth={this.state.width}
              menuItems={menuItemsMain}
              panel={this.state.panelMain}
              setPanel={this.setPanelMain}

              marginTop='7px'
              marginBottom='17px'
              fontSize='16px'
            />

            <ZakladkiSecondary
              windowWidth={this.state.width}
              menuItems={menuItemsSecondary}
              panel={this.state.panelSecondary}
              setPanel={this.setPanelSecondary}
              lightMode={this.props.page.lightMode}

              marginTop='0px'
              marginBottom='10px'
              fontSize='14px'
            />
  
            {displayMain === DisplayStateMain.doladuj && displaySecondary === DisplayStateDoladuj.kwotowy ? <KarnetKwotowy/> : null}    
            {displayMain === DisplayStateMain.doladuj && displaySecondary === DisplayStateDoladuj.czasowy ? <KarnetCzasowy/> : null}    
            {displayMain === DisplayStateMain.doladuj && displaySecondary === DisplayStateDoladuj.od_do ? <KarnetOdDo/> : null}    
            
            {displayMain === DisplayStateMain.historia && displaySecondary === DisplayStateHistoria.doladowania ? <HistoriaDoladowania/> : null}    
            {displayMain === DisplayStateMain.historia && displaySecondary === DisplayStateHistoria.zjazdy ? <HistoriaZjazdow/> : null}    
            {displayMain === DisplayStateMain.historia && displaySecondary === DisplayStateHistoria.karnet ? <TwojKarnet/> : null}    
            
            {displayMain === DisplayStateMain.ty_i_my && displaySecondary === DisplayStateRegulaminy.wypozyczenia ? <Wypozyczenia/> : null}    
            {displayMain === DisplayStateMain.ty_i_my && displaySecondary === DisplayStateRegulaminy.zamowienia ? <Zamowienia/> : null}    
            {displayMain === DisplayStateMain.ty_i_my && displaySecondary === DisplayStateRegulaminy.zgody ? <Zgody/> : null}    
            
            {displayMain === DisplayStateMain.wypozycz && displaySecondary === DisplayStateWypozycz.najwazniejsze ? <WypozyczNajwazniejsze setPanel={this.setPanelMain}/> : null}    
            {displayMain === DisplayStateMain.wypozycz && displaySecondary === DisplayStateWypozycz.wypozyczenia ? <WypozyczHistoria/> : null}    
            
            {displayMain === DisplayStateMain.zjedz && displaySecondary === DisplayStateZjedz.najwazniejsze ? <Zjedz setPanel={this.setPanelMain}/> : null}    
            {displayMain === DisplayStateMain.zjedz && displaySecondary === DisplayStateZjedz.zamowienia ? <ZjedzHistoria/> : null}    
            
            {displayMain === DisplayStateMain.zanocuj && displaySecondary === DisplayStateZanocuj.najwazniejsze ? <Zanocuj/> : null}    
            {displayMain === DisplayStateMain.zanocuj && displaySecondary === DisplayStateZanocuj.noclegi ? <ZanocujHistoria/> : null}    
            
            {displayMain === DisplayStateMain.zalinkuj && displaySecondary === DisplayStateZalinkuj.najwazniejsze ? <ZalinkujNajwazniejsze/> : null}    
            {displayMain === DisplayStateMain.zalinkuj && displaySecondary === DisplayStateZalinkuj.cenniki ? <Cenniki/> : null}    
            {displayMain === DisplayStateMain.zalinkuj && displaySecondary === DisplayStateZalinkuj.inne ? <Inne/> : null}    
            
            {displayMain === DisplayStateMain.opinie && displaySecondary === DisplayStateOpinie.najwazniejsze ? <Podoba/> : null}    
            {/* {displayMain === DisplayStateMain.opinie && displaySecondary === DisplayStateOpinie.podoba ? <Podoba/> : null}    
            {displayMain === DisplayStateMain.opinie && displaySecondary === DisplayStateOpinie.poprawa ? <Poprawa/> : null}    
            {displayMain === DisplayStateMain.opinie && displaySecondary === DisplayStateOpinie.sugestia ? <Sugestia/> : null}     */}

            {displayMain === DisplayStateMain.web && displaySecondary === DisplayStateWeb.najwazniejsze ? <Web/> : null}    
                
           
           
           

            {displayMain === DisplayStateMain.serwis ? <Serwis windowWidth={this.state.width} /> : null}

            {displayMain === DisplayStateMain.powiadomienia ? <Powiadomienia windowWidth={this.state.width} /> : null}

            {/* <button onClick={this.setTheme} ></button> */}

            

            {/* <Grid container direction="row" alignItems='center' alignContent='center' justifyContent='center'  style={{  }}>
              <Grid key={"11"} item style={{ width: "200px" }}>
                <Button
                  style={{ width: "calc(100% )", padding: "14px 0px", whiteSpace: "pre", fontSize: "16px" }}
                  className={`${classes.inputChosen } ${classes.border} ${ classes.inputText }`}
                  variant="outlined" color="primary"
                  onClick={() => {}}
                >
                  {"koniec"}
                </Button>
              </Grid>
            </Grid> */}

            {displayMain === DisplayStateMain.doladuj ? <RegulaminyFooter openKlawiatura={this.openKlawiaturaBackdrop}/> : <LogoFooter /> }

            {this.props.page.tablet ?
            <Grid item xs={12} alignItems='center' justify="center" style={{ width: "100%", display: "flex", marginTop: "25px"}}>
              <Fab
                color={"secondary"}
                aria-label="map"
                onClick={() => { this.closeSite() }}
                style={this.state.width > 600 ? { height: "90px", width: "110px", bottom: "45px", right: "45px", } : { height: "60px", width: "80px", bottom: "30px", right: "30px", }}
                className={classes.fab}
              >
                <Typography style={{ textTransform: "none", fontSize: this.state.width > 600 ? "20px" : "16px", fontWeight: "bold", color: "white", lineHeight: "1.2" }}>
                  {"zamknij " + this.props.page.karnet.logo}
                  {/* <SmsIcon style={{ fontSize: "30px",  marginTop: "6px", color: "white" }} /> */}
                </Typography>
              </Fab>
              </Grid> : null}


          </Grid>

          <div id="dialog"></div>
          <Klawiatura open={this.state.openKlawiaturaKarnet} close={this.closeKlawiatura} closeAll={this.closeKlawiatura} setNumber={this.wpiszKarnet} number={0} id={1} max={5} title="wpisz numer karnetu" placeholder={this.state.karnetNumer} karnet backdropClick={this.state.backdropClick}/>
          <MuiThemeProvider theme={themeBlue}>
            <Klawiatura open={this.state.openKlawiaturaTelefon} close={this.closeTelefon} closeAll={this.closeKlawiatura} setNumber={this.wpiszKarnet} number={0} id={1} max={11} title="a teraz wpisujemy telefon" placeholder="" telefon />
          </MuiThemeProvider>

          <OknoInfo/>
        </MuiThemeProvider>

        <WebSocket/> 
      </div>
    );
  }
}

const styles = (theme: Theme) => ({
  root: {
    //padding: "20px 30px 10px",
    margin: "0",
    //height: "90vh",
    //minHeight: "90vh",
    //background: `url(${tloUrl})`,
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  },
  container: {
    //height: "85vh",
    margin: "0em auto",
    paddingTop: "0em",
    padding: '0em',
    width: "100%",
    maxWidth: "1200px", //"1340px",
    //minHeight: "95vh"
  },
  container1: {
    //margin: "0em",
    //paddingTop: "0.4em",
    margin: "0em auto",
    padding: '2em 5em',
    minHeight: "100%",
    maxWidth: "1340px",
    border: "2px solid lavender"
  },
  item: {
    minHeight: "150px",
    maxHeight: "50vh"
  },
  paper : {
    //padding: "0px 6px", 
    //margin: "4px 4px", 
    //background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
    //szymek background: "#fcfcfc",
    position: "relative" as "relative",
    height: "50px"
},
title: {
  // "@media (max-width: 450px)": {
  //   paddingLeft: "142px",
  //   justifyContent: "left"
  // }
},
button: { 
  fontSize: "16px", 
  height: "100%", 
  width: "100%",
  textTransform: "none" as "none",
  //fontWeight: "bold" as "bold",
  padding: "5px",
  //fontWeight: "bold" as "bold"
  "&:hover": {
    //color: "red",
    opacity: "70%"
  }
},
fab: {
  zIndex: 1000,
  //position: "fixed" as "fixed",
  position: "inherit" as "inherit",
  backgroundColor: "rgb(255, 165, 0)",
  "&:hover": {
    backgroundColor: "rgb(178, 115, 0)",
  }
},
backdrop: {
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
},
menuItem: {
  whiteSpace: "pre" as "pre",
  paddingBottom: "8px",
  paddingTop: "8px",
  minHeight: "44px",
},
green: {
  //color: 'rgba(69, 139, 0, 0.5)'
  color: 'rgba(40, 160, 0, 0.8)'
},
divider: {
  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundClip: 'padding-box',
},
menuText: {
  fontSize: "0.85rem"
},

inputChosen: {
  fontSize: "18px",
  //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
  lineHeight: "18px",
  fontWeight: "bold" as "bold",
  //textTransform: "lowercase" as "lowercase",
  padding: "14px",
  height: "40px",
  //backgroundColor: tabStyle.colorMain, //"#56d242",
  backgroundColor: tabStyle.colorHover, //"#56d242",
  //color: tabStyle.colorText,
  "&:hover": {
    //background: tabStyleSecondary.colorHover, //"#007000",
    //color: tabStyleSecondary.colorBackground,
    background: tabStyle.colorHover, 
    color: tabStyle.colorText,
  }
},
inputText: {
  color: tabStyleSecondary.colorText
  //color: tabStyle.colorText
},
border: {
  borderStyle: "solid",
  borderWidth: "1px 0px",
  borderColor: "lavender",
  borderRadius: "0px",
 
},
lightMode: {

},
darkMode: {
  backgroundColor: DARK_BACKGROUND_COLOR
}
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(App))); 

